import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function isAbortLikeError(error) {
  const valuesToInspect = [
    error?.name,
    error?.message,
    error?.error,
    error?.error?.name,
    error?.error?.message,
    error?.cause?.name,
    error?.cause?.message,
    error?.details,
    error?.details?.name,
    error?.details?.message,
    error,
  ]

  return valuesToInspect.some((value) => {
    const text = String(
      typeof value === "string" ? value : value?.message || value?.name || ""
    )

    return text === "AbortError" || /operation was aborted|aborted/i.test(text)
  })
}

export function getErrorSummary(error) {
  if (!error) return { message: "Error desconocido" }
  if (typeof error === "string") return { message: error }

  const nestedMessage =
    error?.message ||
    (typeof error?.error === "string" ? error.error : undefined) ||
    error?.error?.message ||
    error?.details?.message ||
    (typeof error?.details === "string" ? error.details : undefined)

  const nestedName =
    error?.name ||
    error?.error?.name ||
    error?.details?.name

  const nestedCode =
    error?.code ||
    error?.error?.code ||
    error?.details?.code

  const nestedStatus =
    error?.status ||
    error?.statusCode ||
    error?.error?.status ||
    error?.details?.status

  const summary = {
    name: nestedName || undefined,
    message: nestedMessage || "Error desconocido",
    code: nestedCode || undefined,
    status: nestedStatus || undefined,
    details: error?.details || error?.error?.details || undefined,
    hint: error?.hint || error?.error?.hint || undefined,
  }

  if (error?.stack) {
    summary.stack = error.stack
  }

  return summary
}

export function logError(context, error, options = {}) {
  if (options.ignoreAbort && isAbortLikeError(error)) {
    return
  }

  console.error(context, getErrorSummary(error))
}
